(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('[data-cart]').forEach(function (root) {
    var form = root.querySelector('[data-cart-form]');
    if (!form) return;

    /* 数量を変えたら反映する。連打をまとめる目的の待ち時間なので、
       体感に出ない範囲まで詰めている。 */
    var timer = null;
    function submitSoon(delay) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      }, delay);
    }

    form.addEventListener('click', function (e) {
      var step = e.target.closest('[data-cart-step]');
      if (!step) return;
      var field = step.parentNode.querySelector('[data-cart-qty]');
      if (!field) return;
      var next = parseInt(field.value, 10) + parseInt(step.dataset.cartStep, 10);
      field.value = Math.max(0, next);
      submitSoon(150);
    });

    /* 直接入力は打ち終わりが読めないので、ボタンより少しだけ待つ。 */
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-cart-qty]')) submitSoon(250);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["center-caps"] && !Shopify.designMode) return;
  try {
    
  /* メーカータブ。各セクションで独立して動く。 */
  document.querySelectorAll('.tabs').forEach(function (list) {
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }

    list.addEventListener('click', function (e) {
      var tab = e.target.closest('[role="tab"]');
      if (tab) select(tab, false);
    });

    list.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      var next = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 }[e.key];
      if (next === undefined) return;
      e.preventDefault();
      select(tabs[(next + tabs.length) % tabs.length], true);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-pdp]').forEach(function (root) {
    var dataEl = document.querySelector('[data-pdp-variants]');
    if (!dataEl) return;

    var variants = JSON.parse(dataEl.textContent);
    var idField = root.querySelector('[data-pdp-id]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var addBtn = root.querySelector('[data-pdp-add]');
    var addLabel = root.querySelector('[data-pdp-add-label]');
    var mainImg = root.querySelector('[data-pdp-main]');
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-option]'));
    if (!inputs.length) return;

    /* name は option1 / option2 ... なので末尾の数字が位置になる */
    function posOf(input) {
      return parseInt(input.name.replace('option', ''), 10) - 1;
    }

    var optionCount = inputs.reduce(function (n, i) {
      return Math.max(n, posOf(i) + 1);
    }, 0);

    function chosenValues() {
      var out = [];
      inputs.forEach(function (i) {
        if (i.checked) out[posOf(i)] = i.value;
      });
      return out;
    }

    function money(cents) {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'JPY';
      var ja = (document.documentElement.lang || '').indexOf('ja') === 0;
      var out;
      try {
        out = new Intl.NumberFormat(ja ? 'ja-JP' : 'en', {
          style: 'currency',
          currency: cur
        }).format(cents / 100);
      } catch (e) {
        out = (cents / 100).toLocaleString();
      }
      return ja ? out.replace('￥', '¥') : out + ' ' + cur;
    }

    /* ある位置にある値が、前段の選択のもとで成立するかを調べる。
       絞り込みを前段からの一方向にすることで、
       「完成品を選ぶと種類からベースが消える」「ベースのみを選ぶとベースだけ残る」
       という関係になる。 */
    function probe(pos, value, prefix) {
      var found = { exists: false, inStock: false };
      variants.forEach(function (v) {
        if (v.options[pos] !== value) return;
        for (var i = 0; i < prefix.length; i++) {
          if (prefix[i] !== undefined && v.options[i] !== prefix[i]) return;
        }
        found.exists = true;
        if (v.available) found.inStock = true;
      });
      return found;
    }

    /* 前段を変えた結果、後段の選択が成立しなくなったら選び直す。
       これが無いと「完成品＋VS赤」から「ベースのみ」へ移れなくなる。 */
    function repair(from) {
      var chosen = chosenValues();
      for (var pos = from; pos < optionCount; pos++) {
        var prefix = chosen.slice(0, pos);
        if (chosen[pos] !== undefined && probe(pos, chosen[pos], prefix).exists) continue;

        var pick = null;
        inputs.forEach(function (input) {
          if (posOf(input) !== pos) return;
          var state = probe(pos, input.value, prefix);
          if (!state.exists) return;
          if (!pick || (state.inStock && !pick.inStock)) {
            pick = { input: input, inStock: state.inStock };
          }
        });

        if (pick) {
          pick.input.checked = true;
          chosen[pos] = pick.input.value;
        }
      }
    }

    function paint(chosen) {
      inputs.forEach(function (input) {
        var pos = posOf(input);
        var state = probe(pos, input.value, chosen.slice(0, pos));
        var label = root.querySelector('label[for="' + input.id + '"]');

        input.disabled = input.checked ? false : !state.inStock;

        if (label) {
          label.classList.toggle('is-gone', !state.exists);
          label.classList.toggle('is-out', state.exists && !state.inStock);
        }
      });
    }

    function setMain(src) {
      if (!mainImg) return;
      mainImg.src = src;
      root.querySelectorAll('[data-pdp-thumb]').forEach(function (t) {
        t.classList.toggle('is-on', t.dataset.full === src);
      });
    }

    function sync(changedPos) {
      if (changedPos !== undefined) repair(changedPos + 1);

      var chosen = chosenValues();
      paint(chosen);

      var match = null;
      variants.forEach(function (v) {
        if (match) return;
        for (var i = 0; i < optionCount; i++) {
          if (v.options[i] !== chosen[i]) return;
        }
        match = v;
      });
      if (!match) return;

      idField.value = match.id;
      priceEl.textContent = money(match.price);
      addBtn.disabled = !match.available;
      addLabel.textContent = match.available
        ? addBtn.dataset.labelAdd
        : addBtn.dataset.labelSold;

      if (match.featured_image && mainImg) setMain(match.featured_image.src);
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-pdp-option]')) sync(posOf(e.target));
    });

    root.querySelectorAll('[data-pdp-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setMain(thumb.dataset.full);
      });
    });

    /* 読み込み直後の状態にも制限を反映させる */
    sync();
  });

  } catch(e) { console.error(e); }
})();
})();
